import { NavLink, Link } from "react-router-dom"
import { useState } from "react"
const logoSrc = "/images/Jero-One_Logo.png";
import { useCart } from "../context/CartContext"

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/shop", label: "Shop" },
  { to: "/training", label: "Training" },
  { to: "/websites", label: "Websites" },
  { to: "/about", label: "About Us" },
  { to: "/locations", label: "Locations" },
  { to: "/contact", label: "Contact" },
]

export function Navbar() {
  const [open, setOpen] = useState(false)
  const { count } = useCart()

  return (
    <header
      className="sticky top-0 z-50 bg-[#0A0F0B] border-b border-[#1B5E35]/20"
      style={{ backdropFilter: "blur(12px)" }}
    >
      {/* Top ribbon */}
      <div className="bg-[#1B5E35] py-1.5 px-6 text-center text-xs text-[#F4F6F0]/80 font-mono tracking-widest hidden md:block">
        🌍 GLOBAL HEADQUARTERS: MINNESOTA, USA &nbsp;·&nbsp; 🇺🇬 UGANDA
        &nbsp;·&nbsp; 🇨🇦 CANADA
      </div>
      <nav className="flex items-center justify-between px-6 md:px-14 py-4">
        <Link to="/" className="flex items-center gap-3">
          <img
            src={logoSrc}
            alt="Jero-One Technologies"
            className="w-10 h-10 object-contain"
          />
          <div>
            <div
              className="font-black text-[#F4F6F0] text-sm tracking-wider leading-none"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            >
              JERO-ONE TECHNOLOGIES
            </div>
            <div className="text-[10px] text-[#1B5E35] font-mono tracking-widest leading-none mt-0.5">
              INC. · EST. 2009
            </div>
          </div>
        </Link>

        {/* Desktop links */}
        <div className="hidden lg:flex items-center gap-0.5">
          {LINKS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium transition-colors rounded-lg ${
                  isActive
                    ? "text-[#F4F6F0] bg-[#1B5E35]/20 text-[#2A7D4A]"
                    : "text-[#6B7C6E] hover:text-[#F4F6F0] hover:bg-[#111A14]"
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </div>

        <Link
          to="/checkout"
          className="hidden xl:block bg-[#1B5E35] hover:bg-[#2A7D4A] text-[#F4F6F0] text-sm font-bold px-5 py-2.5 rounded-lg transition-colors"
        >
          Cart ({count})
        </Link>

        {/* Mobile toggle */}
        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden flex flex-col gap-1.5 p-2"
          aria-label="Toggle menu"
        >
          <span
            className={`block h-0.5 w-6 bg-[#F4F6F0] transition-all ${
              open ? "rotate-45 translate-y-2" : ""
            }`}
          />
          <span
            className={`block h-0.5 w-6 bg-[#F4F6F0] transition-all ${
              open ? "opacity-0" : ""
            }`}
          />
          <span
            className={`block h-0.5 w-6 bg-[#F4F6F0] transition-all ${
              open ? "-rotate-45 -translate-y-2" : ""
            }`}
          />
        </button>
      </nav>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-[#111A14] border-t border-[#1B5E35]/20 px-6 py-4 flex flex-col gap-2">
          {LINKS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `px-4 py-3 text-sm font-medium rounded-lg ${
                  isActive ? "text-[#2A7D4A] bg-[#1B5E35]/10" : "text-[#6B7C6E]"
                }`
              }
            >
              {label}
            </NavLink>
          ))}
          <Link
            to="/checkout"
            onClick={() => setOpen(false)}
            className="mt-2 bg-[#1B5E35] text-[#F4F6F0] text-sm font-bold px-4 py-3 rounded-lg text-center"
          >
            Cart ({count})
          </Link>
        </div>
      )}
    </header>
  )
}
